import React from "react";
import { LOGO_URL, COMPANY, NAV_LINKS } from "@/lib/site-data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-10 border-t border-white/10 bg-[var(--bg-primary)] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <img
                src={LOGO_URL}
                alt="Creative Property Development"
                className="h-14 w-14 object-contain"
              />
              <div>
                <div className="font-display text-xl leading-tight">
                  Creative Property
                </div>
                <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--accent)]">
                  Development
                </div>
              </div>
            </div>
            <p className="text-[var(--text-secondary)] leading-relaxed max-w-sm">
              General contracting and property development for people who care
              how it's built.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow mb-6">Explore</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="font-display text-xl text-[var(--text-primary)] hover:text-[var(--accent)] transition-colors duration-500"
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow mb-6">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="font-display text-xl text-[var(--text-primary)] hover:text-[var(--accent)] transition-colors duration-500"
                  data-testid="footer-email"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.phone.replace(/\D/g, "")}`}
                  className="font-display text-xl text-[var(--text-primary)] hover:text-[var(--accent)] transition-colors duration-500"
                  data-testid="footer-phone"
                >
                  {COMPANY.phone}
                </a>
                <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--text-secondary)] mt-1">
                  Office
                </div>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.phoneMobile.replace(/\D/g, "")}`}
                  className="font-display text-xl text-[var(--text-primary)] hover:text-[var(--accent)] transition-colors duration-500"
                  data-testid="footer-phone-mobile"
                >
                  {COMPANY.phoneMobile}
                </a>
                <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--text-secondary)] mt-1">
                  Mobile
                </div>
              </li>
              <li className="pt-2">
                <a
                  href="https://www.azimuthrenew.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 w-fit"
                  data-testid="footer-azimuth-link"
                >
                  <span className="bg-white rounded-lg px-3 py-2 shadow-lg shrink-0">
                    <img
                      src="/azimuth-logo.png"
                      alt="Azimuth Renewable Energy logo"
                      className="h-16 w-auto object-contain"
                      loading="lazy"
                    />
                  </span>
                  <span className="flex flex-col leading-tight">
                    <span className="font-display text-xl text-[var(--text-primary)] group-hover:text-[var(--accent)] transition-colors duration-500">
                      Azimuth Renewable Energy
                    </span>
                    <span className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--text-secondary)] mt-1">
                      Solar Partner
                    </span>
                  </span>
                </a>
              </li>
              <li className="font-body text-sm text-[var(--text-secondary)]">
                {COMPANY.address}
              </li>
              <li
                className="font-body text-sm text-[var(--text-primary)] pt-1"
                data-testid="footer-service-area"
              >
                {COMPANY.serviceArea}
              </li>
            </ul>
          </div>
        </div>

        <h2
          className="font-display italic text-[14vw] md:text-[11rem] leading-[0.9] tracking-tight text-[var(--text-primary)] select-none"
          aria-hidden="true"
        >
          Creative<span className="text-[var(--accent)]">.</span>
        </h2>

        <div className="pt-8 mt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
          <p className="text-xs text-[var(--text-secondary)]">
            © {year} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-[var(--text-secondary)] font-body tracking-widest uppercase">
            {COMPANY.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
